export default __webpack_public_path__ + "images/OS.8efa4b9.png";